import Modal from "@/components/Modal";

import "./style.css";

export default class RegistrationSuccessModal extends Modal {
  static selector = ".registration-success-modal";

  constructor(block) {
    super(block);

    this.block = block;
    this.loginCta = this.block.querySelector(".button--login-cta");
  }

  handleLoginClick = () => {
    window.App.modals.login.open();
  };

  // Lifecycle methods
  onReady() {
    if (this.loginCta) {
      this.loginCta.addEventListener("click", this.handleLoginClick);
    }
  }

  modalDidMount = async () => {};
  modalWillOpen = async () => {};

  modalDidUpdate = async () => {};
  modalDidClose = async () => {};

  onDestroy() {
    if (this.loginCta) {
      this.loginCta.removeEventListener("click", this.handleLoginClick);
    }
    clearTimeout(this.modalTimeout);
  }
}
